import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "control-panl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["ContrlPanl"], {
      full: "",
      group: $setup.ctrolGroup,
      show: true,
      modelValue: $setup.runs,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.runs) = $event)),
      onSelect: $setup.useSetting
    }, null, 8 /* PROPS */, ["group", "modelValue"])
  ]))
}